import React from 'react';
import {Box, styled} from '@mui/material';
import {designSystemToken} from '@lightricks/react-design-system';

interface CollaborationGigMetadataProps {
  gender?: string;
  ageRange?: string;
  location?: string;
  totalHeight?: string;
}

const DEFAULT_TOTAL_HEIGHT = '88px';

const StyledSecondaryMeta = styled(Box)(() => ({
  flex: '0 0 auto',
  alignItems: 'flex-end',
  display: 'flex',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  padding: '0 20px',
  overflow: 'hidden',
  marginBottom: '18px',
  lineHeight: '24px',
}));

const StyledCreatorMeta = styled(Box)(() => ({
  color: designSystemToken('semantic.fg.secondary'),
  fontSize: '13px',
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'flex-end',
}));

const StyledCreatorMetaItem = styled(Box)(() => ({
  '&:not(:last-child)': {
    'marginRight': '4px',
    '&::after': {
      content: '"•"',
      paddingLeft: '4px',
    },
  },
}));

/**
 * CollaborationGigMetadata component for displaying creator metadata.
 * Shows gender, age range, and location information with bullet separators.
 */
function CollaborationGigMetadata({
  gender,
  ageRange,
  location,
  totalHeight = DEFAULT_TOTAL_HEIGHT,
}: CollaborationGigMetadataProps) {
  return (
    <StyledSecondaryMeta>
      <StyledCreatorMeta style={{maxHeight: totalHeight}}>
        {gender && <StyledCreatorMetaItem>{gender}</StyledCreatorMetaItem>}
        {ageRange && <StyledCreatorMetaItem>{ageRange}</StyledCreatorMetaItem>}
        {location && <StyledCreatorMetaItem>{location}</StyledCreatorMetaItem>}
      </StyledCreatorMeta>
    </StyledSecondaryMeta>
  );
}

export default CollaborationGigMetadata;
